import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Menu, MenuItem } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';

import Base from './Base';

const Item = styled(MenuItem)`
  font-size: 16px !important;
  font-weight: 400 !important;
  padding: 12px 32px !important;
`;

function Select({
  options,
  onSelect,
  value,
  disabled,
  color,
  placeholder,
}) {
  const [open, setOpen] = React.useState(false);

  function closeMenu() {
    setOpen(false);
  }

  function resetMenu() {
    setOpen(false);
  }

  function select(_value) {
    closeMenu();

    onSelect(_value);
  }

  function RenderMenuItem(item, index) {
    function onClick() {
      select(item.value);
    }

    const isSelected = item.value === value;

    return (
      <Item key={index} selected={isSelected} onClick={onClick}>
        {item.title}
      </Item>
    );
  }

  React.useEffect(resetMenu, [disabled]);
  const anchorEl = React.createRef();
  const getAnchor = () => anchorEl.current;

  return [
    <Base
      key="base"
      value={value}
      color={color}
      ref={anchorEl}
      outlined={false}
      options={options}
      setOpen={setOpen}
      disabled={disabled}
      placeholder={placeholder}
    />,

    <Menu
      key="menu"
      open={open}
      onClose={closeMenu}
      anchorEl={getAnchor}
    >
      {options.map(RenderMenuItem)}
    </Menu>,
  ];
}

Select.propTypes = {
  color: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSelect: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

Select.defaultProps = {
  color: blueGrey[800],
  onSelect: null,
  value: '',
  disabled: false,
  placeholder: 'Select',
};

export default Select;
